// extracted by mini-css-extract-plugin
module.exports = {"root":"IconError_root__XmnJU"};